import * as loaders from "@lts/loaders/legacy/legacy";
export { loaders };
export default loaders;
